/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import Loader from '../Common/Loader';
import moment from 'moment-timezone';
import DatePicker from 'react-datepicker';
import constants from '../../constants';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { cookieStorageUtility, localStorageUtility } from '../../utils/utilityFunctions';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');
const syncAllowedVal = cookieStorageUtility.fetch('syncAllowed');

const initialDetail = {
  name: '',
  rateplanCode: 'BAR',
  mealplanId: 1,
  rateplanId: '',
  minLos: 1,
  maxLos: 0,
  description: '',
  currency: '',
  taxInclusion: 0,
  season: [
    {
      checkIn: '',
      checkOut: '',
      rateMasterId: '',
      type: '',
      value: ''
    }
  ],
  checkInDays: ['0', '1', '2', '3', '4', '5', '6'],
  blackOutDays: []
};

const AddRatePlan = (props) => {
  const navigate = useNavigate();
  const [detail, setDetail] = useState(initialDetail);
  const [checkInDays] = useState(['SUN', 'MON', 'TUE', 'WED', 'THR', 'FRI', 'SAT']);
  const [blackOutStart, setBlackOutStart] = useState('');
  const [blackOutEnd, setBlackOutEnd] = useState('');
  const [allDays, setAllDays] = useState(true);
  const [mealList, setMealList] = useState([]);
  const [rateMasterList, setRateMasterList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [showUILoader, setShowUILoader] = useState(true);
  const [syncAllowed] = useState(syncAllowedVal);

  const {rpId} = useParams();

  useEffect(() => {
    getCurrencyList();
    getMealPlanList();
    getRateMasterList();
    if (typeof rpId !== 'undefined' && rpId !== '') {
      getRatePlanDetail(rpId);
    } else {
      setShowUILoader(false);
    }
    // eslint-disable-next-line
  }, []);

  const getRatePlanDetail = (rpId) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'rateplan/getrateplan', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { rpId, hotelId }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setRatePlanDetail(response.data.data);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const setRatePlanDetail = (data) => {
    setDetail(prev => ({
      ...prev,
      name: data.name,
      rateplanCode: data.rateplanCode,
      rateplanId: data.rateplanId,
      mealplanId: data.mealplanId,
      minLos: data.minLos,
      maxLos: data.maxLos,
      description: data.description === null ? '' : data.description,
      currency: data.currency,
      taxInclusion: data.taxIncluded,
      season: data.season.length > 0 ? data.season : prev.season,
      checkInDays: data.checkInDays,
      blackOutDays: data.blackout
    }));
    setAllDays(data.checkInDays.length === 7);
  };

  const getCurrencyList = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    const identity = localStorageUtility.fetch('identity');
    setShowUILoader(true);
    axios(serverUrl + 'common/currencylist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        assignRegionType: identity.assign_region_type,
        assignRegionValue: identity.assign_region_value
      }
    })
      .then(response => {
        if (response.status === 200) {
          setCurrencyList(response.data.currencyList);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const getMealPlanList = () => {
    setShowUILoader(true);
    const hotelId = cookieStorageUtility.fetch('hotelId');
    axios(serverUrl + 'common/mealplanlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId
      }
    })
      .then(response => {
        if (response.status === 200) {
          setMealList(response.data.mealPlanList);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const getRateMasterList = () => {
    setShowUILoader(true);
    const hotelId = cookieStorageUtility.fetch('hotelId');
    axios(serverUrl + 'common/masterlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId
      }
    })
      .then(response => {
        if (response.status === 200) {
          setRateMasterList(response.data.rateMasterList);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => {
      setFlag(false);
    }, 5000);
  };

  const checkValue = (val) => {
    return typeof val === 'undefined' || val === '';
  };

  const validateParam = () => {
    if (checkValue(detail.name)) {
      showMessage('error', 'Please enter rateplan name.');
      return false;
    }
    if (checkValue(detail.rateplanCode)) {
      showMessage('error', 'Please enter rateplan code.');
      return false;
    }
    if (checkValue(detail.mealplanId) || detail.mealplanId < 0) {
      showMessage('error', 'Please select meal.');
      return false;
    }
    if (checkValue(detail.minLos) || detail.minLos < 0) {
      showMessage('error', 'Please select min length of stay.');
      return false;
    }
    if (checkValue(detail.maxLos) || detail.maxLos < 0 || (detail.maxLos !== 0 && detail.maxLos < detail.minLos)) {
      showMessage('error', 'Please select max length of stay.');
      return false;
    }
    if (checkValue(detail.currency)) {
      showMessage('error', 'Please select rateplan currency.');
      return false;
    }
    if (checkValue(detail.taxInclusion)) {
      showMessage('error', 'Please select rate tax inclusion.');
      return false;
    }
    if (detail.season.length < 0) {
      showMessage('error', 'Please enter valid rateplan season.');
      return false;
    }
    return true;
  };

  const createRatePlan = () => {
    const { history } = props;
    const hotelId = cookieStorageUtility.fetch('hotelId');
    if (validateParam()) {
      setShowUILoader(true);
      axios(serverUrl + 'rateplan/createrateplan', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: {
          hotelId,
          rateplan_details: detail
        }
      })
        .then(response => {
          if (response.status === 200) {
            showMessage('success', response.data.message);
            setTimeout(() => {
              navigate('/rateplan');
            }, 2000);
          } else {
            showMessage('error', response.data.message);
          }
          setShowUILoader(false);
        })
        .catch(error => {
          console.log(error);
          setShowUILoader(false);
        });
    }
  };

  const updateRatePlan = () => {
    const { history } = props;
    const hotelId = cookieStorageUtility.fetch('hotelId');
    if (validateParam()) {
      setShowUILoader(true);
      axios(serverUrl + 'rateplan/updaterateplan', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: {
          hotelId,
          rateplan_details: detail
        }
      })
        .then(response => {
          if (response.status === 200) {
            showMessage('success', response.data.message);
            setTimeout(() => {
              navigate('/rateplan');
            }, 2000);
          } else {
            showMessage('error', response.data.message);
          }
          setShowUILoader(false);
        })
        .catch(error => {
          console.log(error);
          setShowUILoader(false);
        });
    }
  };

  const dateChangeRaw = (e) => {
    e.preventDefault();
  };

  const toggelCheck = (val) => {
    setDetail(prev => {
      const newCheckInDays = prev.checkInDays.includes(val)
        ? prev.checkInDays.filter(day => day !== val)
        : [...prev.checkInDays, val];
      setAllDays(newCheckInDays.length === 7);
      return { ...prev, checkInDays: newCheckInDays };
    });
  };

  const renderLos = (min, max) => {
    let los = [];
    for (let i = min; i <= max; i++) {
      if (i === 1) {
        los.push(
          <option value={i} key={i}>
            {i} Night
          </option>
        );
      } else {
        los.push(
          <option value={i} key={i}>
            {i} Nights / {Number(Number(i) + 1)} Days
          </option>
        );
      }
    }
    return los;
  };

  const toggelSelectAllDays = (flag) => {
    if (flag) {
      setDetail(prev => ({ ...prev, checkInDays: [] }));
      setAllDays(false);
    } else {
      setDetail(prev => ({ ...prev, checkInDays: ['0', '1', '2', '3', '4', '5', '6'] }));
      setAllDays(true);
    }
  };

  const handelChangeValue = (e, type) => {
    setDetail(prev => ({ ...prev, [type]: e.target.value }));
  };

  const dateChange = (date, type) => {
    const newDate = moment(date).format('YYYY-MM-DD');
    if (type === 'blackOutStart') setBlackOutStart(newDate);
    else if (type === 'blackOutEnd') setBlackOutEnd(newDate);
    else setDetail(prev => ({ ...prev, [type]: newDate }));
  }
  
  const addBlackOutDate = () => {
    if (blackOutStart === '' || typeof blackOutStart === 'undefined') {
      showMessage('error', 'Select Black Out Start Date');
      return '';
    }
    if (blackOutEnd === '' || typeof blackOutEnd === 'undefined') {
      showMessage('error', 'Select Black Out End Date');
      return '';
    }
    var dates = {
      start: moment(blackOutStart).format('YYYY-MM-DD'),
      end: moment(blackOutEnd).format('YYYY-MM-DD')
    };
    if (!validateUniqueBlackOut(dates)) {
      showMessage('error', 'Blackout date is already exist');
      setBlackOutStart('');
      setBlackOutEnd('');
      return;
    }
    if (!validateBlackOut(dates)) {
      showMessage('error', 'Blackout date is out of rateplan season.');
      setBlackOutStart('');
      setBlackOutEnd('');
      return;
    }
    const newBlackOutDays = [...detail.blackOutDays, dates];
    setDetail(prev => ({ ...prev, blackOutDays: newBlackOutDays }));
    setBlackOutStart('');
    setBlackOutEnd('');
  }

  const removeBlackOutDate = (id) => {
    const newBlackOutDays = detail.blackOutDays.filter((_, index) => index !== id);
    setDetail(prev => ({ ...prev, blackOutDays: newBlackOutDays }));
  }

  const validateBlackOut = (date) => {
    var flag = true;
    if (detail.season.length > 0) {
      var sea = detail.season;
      for (var i = 0; i < sea.length; i++) {
        if (moment(date.end) < moment(sea[i].checkIn) || moment(sea[i].checkOut) < moment(date.start)) {
          flag = false;
        } else {
          flag = true;
        }
      }
    }
    return flag;
  }
  const validateUniqueBlackOut = (date) => {
    var flag = true;
    if (detail.blackOutDays.length > 0) {
      var blackOutDays = detail.blackOutDays;
      for (var i = 0; i < blackOutDays.length; i++) {
        if (moment(date.end) <= moment(blackOutDays[i].start) || moment(blackOutDays[i].end) <= moment(date.start)) {
          continue;
        } else {
          return false;
        }
      }
    }
    return flag;
  }

  const renderBlackOut = () => {
    return (
      <div className="cover bg1 pad10 border_all_1 border_color_1 marg_bottom15 text-start">
        <div className="ovr marg_bottom10 bld">Black Out Dates</div>
        <div className="cover">
          <div className="row">
            {detail.blackOutDays.length > 0
              ? detail.blackOutDays.map((data, id) => {
                return (
                  <div className="col-xs-12 col-md-3 marg_bottom15" key={id}>
                    <div className="table_col table_fixed border_all_1 border_color_1">
                      <div className="tabcel align_middle pad7">
                        {data.start} To {data.end}
                      </div>
                      <div
                        className="tabcel align_middle pad7 wdhpx30 tc bg2_9 color1 cursor_p"
                        onClick={() => removeBlackOutDate(id)}
                      >
                        {' '}
                        <i className="fa fa-times"></i>
                      </div>
                    </div>
                  </div>
                );
              })
              : ''}
          </div>
        </div>
        <div className="cover">
          <div className="row">
            <div className="col-xs">
              <div className="frm border_all_1 border_color_1">
                {' '}
                <span className="ficon pad_lft_rht10">
                  <i className="fa fa-calendar"></i>
                </span>
                <DatePicker
                  inputProps={{ disabled: true }}
                  placeholderText="Black Out Start Date"
                  dateFormat="yyyy-MM-dd"
                  className="input pad_lft_rht10"
                  name="blackOutStart"
                  onChangeRaw={e => dateChangeRaw(e)}
                  onChange={e => dateChange(e, 'blackOutStart')}
                  selected={blackOutStart !== '' ? new Date(blackOutStart) : null}
                />
              </div>
            </div>
            <div className="col-xs">
              <div className="frm border_all_1 border_color_1">
                {' '}
                <span className="ficon pad_lft_rht10">
                  <i className="fa fa-calendar"></i>
                </span>
                <DatePicker
                  inputProps={{ disabled: true }}
                  placeholderText="Black Out End Date"
                  dateFormat="yyyy-MM-dd"
                  className="input pad_lft_rht10"
                  name="blackOutEnd"
                  minDate={blackOutStart !== '' ? new Date(blackOutStart) : null}
                  onChangeRaw={e => dateChangeRaw(e)}
                  onChange={e => dateChange(e, 'blackOutEnd')}
                  selected={blackOutEnd !== '' ? new Date(blackOutEnd) : null}
                />
              </div>
            </div>
            <div className="col-xs-auto">
              <div
                className="d-full-height justify-content-center pad_lft_rht15 tc bg2_9 color1 cursor_p"
                onClick={() => addBlackOutDate()}
              >
                Add
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  const addSeason = () => {
    setDetail(prev => ({
      ...prev,
      season: [
        ...prev.season,
        {
          checkIn: '',
          checkOut: '',
          rateMasterId: '',
          type: '',
          value: ''
        }
      ]
    }));
  }

  const removeSeason = (id) => {
    const newSeason = detail.season.filter((_, index) => index !== id);
    setDetail(prev => ({ ...prev, season: newSeason }));
  }

  const handelSeasonValue = (e, key, id) => {
    const val = key === 'checkIn' || key === 'checkOut' ? moment(e).format('YYYY-MM-DD') : e.target.value;
    setDetail(prev => {
      const newSeason = prev.season.map((season, index) => {
        if (index === id) {
          return { ...season, [key]: val };
        }
        return season;
      });
      return { ...prev, season: newSeason };
    });
    validateDateRange();
  }

  const validateDateRange = () => {
    if (detail.season.length > 1) {
      var j = 0;
      var sea = detail.season;
      for (var i = 1; i < sea.length; i++) {
        var season1 = sea[j];
        var season2 = sea[i];
        if (season2.checkIn === '' || season2.checkOut === '') {
          continue;
        }
        if (
          moment(season2.checkOut) <= moment(season1.checkIn) ||
          moment(season1.checkOut) <= moment(season2.checkIn)
        ) {
          continue;
        } else {
          const newSeason = sea.map((season, index) => {
            if (index === i) {
              return { ...season, checkIn: '', checkOut: '' };
            }
            return season;
          });
          setDetail(prev => ({ ...prev, season: newSeason }));
          showMessage('error', 'Date Range already exist');
          break;
        }
      }
    }
  }

  const cancel = () => {
    const { history } = props;
    navigate('/rateplan');
  }

  const renderSeason = () => {
    return Object.keys(detail.season).map(id => {
      var season = detail.season[id];
      return (
        <div className="loop ovr" key={id}>
          <div className="table_col table_fixed">
            <div className="table_cell align_top">
              <div className="ovr">
                <div className="row gutters-5">
                  <div className="col-xs-12 col-md marg_bottom10">
                    <div className="frm border_all_1 border_color_1">
                      {' '}
                      <span className="ficon pad_lft_rht5">
                        <i className="fa fa-calendar"></i>
                      </span>
                      <DatePicker
                        inputProps={{ disabled: true }}
                        placeholderText="Check In"
                        dateFormat="yyyy-MM-dd"
                        className="input pad_lft_rht5"
                        name="check_in"
                        onChangeRaw={e => dateChangeRaw(e)}
                        onChange={e => handelSeasonValue(e, 'checkIn', id)}
                        selected={season.checkIn !== '' ? new Date(season.checkIn) : null}
                      />
                    </div>
                  </div>
                  <div className="col-xs-12 col-md marg_bottom10">
                    <div className="frm border_all_1 border_color_1">
                      {' '}
                      <span className="ficon pad_lft_rht5">
                        <i className="fa fa-calendar"></i>
                      </span>
                      <DatePicker
                        inputProps={{ disabled: true }}
                        placeholderText="Check Out"
                        dateFormat="yyyy-MM-dd"
                        className="input pad_lft_rht5"
                        name="check_out"
                        minDate={season.checkIn !== '' ? new Date(season.checkIn) : null}
                        onChangeRaw={e => dateChangeRaw(e)}
                        onChange={e => handelSeasonValue(e, 'checkOut', id)}
                        selected={season.checkOut !== '' ? new Date(season.checkOut) : null}
                      />
                    </div>
                  </div>
                  {syncAllowed === 0 ? (
                    <React.Fragment>
                      <div className="col-xs-12 col-md marg_bottom10">
                        <div className="frm border_all_1 border_color_1">
                          {' '}
                          <span className="ficon pad_lft_rht10">
                            <i className="fa fa-chevron-down"></i>
                          </span>
                          <select
                            className="input pad_lft_rht10"
                            value={season.rateMasterId}
                            onChange={e => handelSeasonValue(e, 'rateMasterId', id)}
                          >
                            <option value="">Select Rate</option>
                            {Object.keys(rateMasterList).map((val, i) => {
                              return (
                                <option key={i} value={rateMasterList[val].ratemaster_id}>
                                  {rateMasterList[val].ratename}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="col-xs-12 col-md marg_bottom10">
                        <div className="frm border_all_1 border_color_1">
                          {' '}
                          <span className="ficon pad_lft_rht10">
                            <i className="fa fa-chevron-down"></i>
                          </span>
                          <select
                            className="input pad_lft_rht10"
                            value={season.type}
                            onChange={e => handelSeasonValue(e, 'type', id)}
                          >
                            <option value="">Choose Type</option>
                            <option value="flat">Flat</option>
                            <option value="percentage">Percentage</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-xs-12 col-md marg_bottom10">
                        <div className="frm border_all_1 border_color_1">
                          <input
                            type="text"
                            placeholder="eg + 200, 10%, -15%, -300 "
                            className="input pad_lft_rht5"
                            value={season.value}
                            onChange={e => handelSeasonValue(e, 'value', id)}
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
            <div className="table_cell align_top pad_left10 wdhpx100">
              <div className="row gutters-5">
                <div className="col-xs">
                  {detail.season.length - 1 === id ? (
                    <div className="ovr pad_top_bot7 tc bg2_9 color1" onClick={() => addSeason()}>
                      <i className="fa fa-plus"></i>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="col-xs">
                  {detail.season.length > 1 ? (
                    <div className="ovr pad_top_bot7 tc bg2_9 color1" onClick={() => removeSeason(id)}>
                      <i className="fa fa-trash"></i>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }
  const renderCheckInDays = () => {
    return (
      <div className="cover bg1 pad10 border_all_1 border_color_1 marg_bottom15">
        <div className="cover">
          <div className="ovr marg_bottom10 bld">Travel Date</div>
          {renderSeason()}
        </div>
        <div className="cover margtop20">
          <div className="cover marg_bottom10">
            <div className="row gutters-5">
              <div className="col-xs-auto">Check-in Day</div>
              <div className="col-xs-auto">
                <label>
                  <input
                    type="checkbox"
                    className="margtop2"
                    value={allDays}
                    checked={allDays}
                    onChange={() => toggelSelectAllDays(allDays)}
                  />
                  <div className="inline align_top bld">Select All</div>
                </label>
              </div>
            </div>
          </div>
          <div className="cover marg_bottom10">
            <div className="table_col table_fixed">
              {checkInDays.map((val, id) => {
                id = id.toString();
                return (
                  <div
                    key={`checkIn-${id}`}
                    className={`tabcel align_middle  pad10 border_all_1 border_color_1 ${
                      detail.checkInDays.indexOf(id) > -1 ? 'bg2_9 color1' : ''
                    }`}
                    onClick={() => toggelCheck(id)}
                  >
                    <div className="row no-gutters">
                      <div className="col-xs-auto">
                        {' '}
                        <i className={`fa ${detail.checkInDays.indexOf(id) > -1 ? 'fa-check' : ''}`}></i>
                      </div>
                      <div className="col-xs tc">{val}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="cover">
            <div className="row justify-content-end">
              <div className="col-xs-auto cursor_p">
                <div className="inline align_middle wh20 marg_right3 bg2_9"></div>
                <div className="inline align_middle bld">Selected</div>
              </div>
              <div className="col-xs-auto cursor_p">
                <div className="inline align_middle wh20 marg_right3 border_all_2 border_color_1"></div>
                <div className="inline align_middle bld">Not Selected</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">
              {typeof rpId !== 'undefined' && rpId !== '' ? 'Edit' : 'Add'} Rate Plan
            </div>
          </div>
        </div>
      </div>
      {flag ? (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>
          {message}
        </div>
      ) : (
        ''
      )}
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="container">
          <div className="cover">
            <div className="row">
              <div className="col-xs-12 col-md-6 marg_bottom15">
                <label className="ovr marg_bottom5 bld">Name</label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht10"
                    value={detail.name}
                    onChange={e => handelChangeValue(e, 'name')}
                  />
                </div>
              </div>

              <div className="col-xs-12 col-md-6 marg_bottom15">
                <label className="ovr marg_bottom5 bld">Rateplan Code</label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht10"
                    disabled={true}
                    value={detail.rateplanCode}
                    onChange={e => handelChangeValue(e, 'rateplanCode')}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-md-6 marg_bottom15">
                <label className="ovr marg_bottom5 bld">Meal</label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={detail.mealplanId}
                    onChange={e => handelChangeValue(e, 'mealplanId')}
                  >
                    {Object.keys(mealList).map((id, i) => {
                      return (
                        <option key={i} value={mealList[id].id}>
                          {mealList[id].meal_plan_name} ({mealList[id].meal_code})
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-xs-12 col-md-6 marg_bottom15">
                <label className="ovr marg_bottom5 bld">Min Length of Stay</label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={detail.minLos}
                    onChange={e => handelChangeValue(e, 'minLos')}
                  >
                    {renderLos(1, 20)}
                  </select>
                </div>
              </div>
              <div className="col-xs-12 col-md-6 marg_bottom15">
                <label className="ovr marg_bottom5 bld">Maximum Length of Stay</label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={detail.maxLos}
                    onChange={e => handelChangeValue(e, 'maxLos')}
                  >
                    <option value={0} key={0}>
                      Unlimited
                    </option>
                    {renderLos(detail.minLos, 100)}
                  </select>
                </div>
              </div>
            </div>
          </div>
          {renderCheckInDays()}
          {renderBlackOut()}
          <div className="cover">
            <div className="row">
              <div className="col-xs-6 marg_bottom15">
                <label className="ovr marg_bottom5 bld">Currency</label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={detail.currency}
                    onChange={e => handelChangeValue(e, 'currency')}
                  >
                    <option value="">Select Currency</option>
                    {Object.keys(currencyList).map((id, i) => {
                      return (
                        <option key={i} value={currencyList[id]}>
                          {currencyList[id]}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-xs-6 marg_bottom15">
                <label className="ovr marg_bottom5 bld">Rates inclusion of Tax</label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={detail.taxInclusion}
                    onChange={e => handelChangeValue(e, 'taxInclusion')}
                  >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>
              <div className="col-xs-12 marg_bottom15">
                <label className="ovr marg_bottom7 bld">Description</label>
                <div className="frm border_all_1 border_color_1">
                  <textarea
                    name=""
                    cols=""
                    rows=""
                    className="tera"
                    value={detail.description}
                    onChange={e => handelChangeValue(e, 'description')}
                  ></textarea>
                </div>
              </div>
              <div className="col-xs-12 marg_bottom15 tr">
                {typeof rpId !== 'undefined' && rpId !== '' ? (
                  <div
                    className="inline btn1 pad_top_bot5 marg_right10 pad_lft_rht20 cursor_p"
                    onClick={() => updateRatePlan()}
                  >
                    Update
                  </div>
                ) : (
                  <div
                    className="inline btn1 pad_top_bot5 marg_right10 pad_lft_rht20 cursor_p"
                    onClick={() => createRatePlan()}
                  >
                    Save
                  </div>
                )}
                <div
                  className="inline btn1 pad_top_bot5 marg_right10 pad_lft_rht20 cursor_p"
                  onClick={() => cancel()}
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddRatePlan;
